/*
 * Copyright 2025 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { PermissionDependentPluginList } from '@backstage-community/plugin-rbac-common';

export function validatePermissionDependentPlugin(
  plugin: PermissionDependentPluginList,
) {
  if (!plugin.ids) {
    throw new Error(
      `'ids' must be specified in the permission dependent plugin`,
    );
  }
  if (
    !Array.isArray(plugin.ids) ||
    !plugin.ids.every(id => typeof id === 'string')
  ) {
    throw new Error(`'ids' must be an array of string plugin ID values`);
  }
}
